import {DTDistributionNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {toAiOutputType} from '../aiModels/cardDetailsAI.enums';
import {formatOutputHeader, getBaseHeader, getDestinationPhrase, sortOutputsByType} from './utils';

export function distributionCardToText(
  card: DTDistributionNode,
  mode: 'short' | 'full',
  fallbackCreativeNodeId?: number,
): string {
  const header = getBaseHeader(card);
  const sortedOutputs = sortOutputsByType(card.outputs);

  if (mode === 'short') {
    const outputLines = sortedOutputs.map((output, index) => {
      const outputHeader = formatOutputHeader(index, output);
      const dest = getDestinationPhrase(output.nodeId, fallbackCreativeNodeId, output.type);

      return `${outputHeader} ${dest}`;
    });

    return [header, ...outputLines].join('\n');
  }

  const outputLines = sortedOutputs.map((output, index) => {
    const outputHeader = formatOutputHeader(index, output);
    const dest = getDestinationPhrase(output.nodeId, fallbackCreativeNodeId, output.type);
    const typeLabel = toAiOutputType(output.type) ?? '';

    return `${outputHeader} ${dest} type=${typeLabel}`;
  });

  return [header, ...outputLines].join('\n');
}
